import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "revert-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.85836 14.1829C6.72259 11.8871 8.72788 10.0879 11.3131 9.60617C15.2491 8.87269 19.0351 11.4693 19.7686 15.4053C19.8444 15.8125 20.2361 16.0811 20.6433 16.0052C21.0505 15.9293 21.3191 15.5377 21.2432 15.1305C20.3579 10.3801 15.7887 7.24631 11.0383 8.13155C8.06829 8.68501 5.73562 10.6778 4.61769 13.2521L4.23158 11.1801C4.1557 10.7729 3.76408 10.5043 3.35688 10.5802C2.94967 10.6561 2.68108 11.0477 2.75697 11.4549L3.48975 15.3872C3.56564 15.7944 3.95725 16.063 4.36446 15.9872L4.92568 15.8826C4.93614 15.8808 4.94654 15.8789 4.95688 15.8768L8.29676 15.2544C8.70397 15.1785 8.97256 14.7869 8.89667 14.3797C8.82079 13.9725 8.42917 13.7039 8.02197 13.7798L5.85836 14.1829Z" }, null, -1)
  ])))
}
export default { render: render }